export default "__VITE_ASSET__220f9f4a__"